import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const RESUME_INTERVIEW_SOURCES_B = [
  {
    sourceId: "resume-interview-source-presentation",
    topicId: "resume-interview",
    title: "How to present yourself professionally",
    publisher: "Workforce Australia",
    url: "https://www.workforceaustralia.gov.au/individuals/coaching/job-applications/presentation-tips",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Workforce Australia 공식 본문에서 clear communication, clarification requests, interview practice와 role-appropriate professional presentation을 확인",
    reviewStatus: "live_verified",
    claimScope: "application·interview의 professional communication과 presentation",
    followUp: "workplace·industry dress expectation, accessibility와 interview format을 employer에게 확인",
  },
  {
    sourceId: "resume-interview-source-email",
    topicId: "resume-interview",
    title: "Responding to emails from employers when looking for a job",
    publisher: "Workforce Australia",
    url: "https://www.workforceaustralia.gov.au/individuals/coaching/job-applications/emailing-employers",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Workforce Australia 공식 본문에서 shortlist·interview email에 prompt professional reply, details clarification, availability confirmation과 unsolicited-offer scam check를 확인",
    reviewStatus: "live_verified",
    claimScope: "job-search employer email 확인·답변과 interview scheduling",
    followUp: "sender domain, role·company details, interview link와 requested personal information을 확인",
  },
  {
    sourceId: "resume-interview-source-discrimination",
    topicId: "resume-interview",
    title: "Protection from discrimination at work",
    publisher: "Fair Work Ombudsman",
    url: "https://www.fairwork.gov.au/employment-conditions/protections-at-work/protection-from-discrimination-at-work",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Fair Work Ombudsman 공식 본문에서 prospective employee도 protected attributes 때문에 hiring refusal·different terms 등 adverse action으로부터 보호됨을 확인",
    reviewStatus: "live_verified",
    claimScope: "채용·면접 과정의 prospective-employee discrimination 보호",
    followUp: "문제 발생 시 질문·답변·decision reason과 relevant jurisdiction·complaint deadline을 확인",
  },
  {
    sourceId: "resume-interview-source-scam",
    topicId: "resume-interview",
    title: "Jobs and employment scams",
    publisher: "Scamwatch",
    url: "https://www.scamwatch.gov.au/types-of-scams/jobs-and-employment-scams",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "National Anti-Scam Centre Scamwatch 공식 본문에서 unsolicited encrypted-message offers, easy high pay, upfront payment·crypto, identity theft와 employer verification safeguards를 확인",
    reviewStatus: "live_verified",
    claimScope: "job ad·recruiter·task-work scam warning signs와 보호조치",
    followUp: "회사 공식 contact, recruiter identity, job listing과 payment·ID request를 독립적으로 검증",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of RESUME_INTERVIEW_SOURCES_B) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
